import { css } from 'styled-components';

const config = {
  gridSize: 12,
  paddingFluidDefault: 2,
  paddingDefault: 0.5,
  resolutions: ['xs', 'sm', 'md', 'cm', 'lg', 'xl'],
  containerMaxWidth: {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140
  },
  ModalMaxWidth: {
    large: {
      xs: 20,
      sm: 35,
      cm: 45,
      md: 60,
      lg: 63,
      xl: 85
    },
    normal: {
      xs: 20,
      sm: 33,
      cm: 40,
      md: 37,
      lg: 46,
      xl: 40
    }
  },
  ModalSidePadding: {
    xs: 20,
    sm: 20,
    cm: 32,
    md: 64,
    lg: 64,
    xl: 64
  },
  pixelBreakPoints: {
    tabletM: '960px',
    tablet: '767px'
  },
  viewport: {
    xs: 'only screen and (max-width: 47.938rem)',
    //767px smartphone
    sm: 'only screen and (min-width: 48rem) and (max-width: 63.938rem)',
    //768px - 1023px standard tablets
    cm: 'only screen and (min-width: 64rem) and (max-width: 74.938rem)',
    //1024px - 1199px clasic monitor or xl tablets
    md: 'only screen and (min-width: 64rem)',
    //1024px standard laptop
    lg: 'only screen and (min-width: 120rem)',
    //1920px laptops or large monitors 
    xl: 'only screen and (min-width: 160rem)' //laptosp or extra large monitors 
  }
};
const media = config.resolutions.reduce((media, breakpoint) => {
  media[breakpoint] = (...args) => {
    let mqCustom = breakpoint === 'cm' ? JSON.parse(JSON.stringify(args).replace(';', ' !important;')) : args;
    return css(["@media ", "{", "}"], config.viewport[breakpoint], css(...mqCustom));
  };
  return media;
}, {});
const mediaQuery = resolution => media[resolution];
const orderResolutions = props => {
  const onlyResolutions = Object.keys(props).filter(dim => config.resolutions.includes(dim));
  return onlyResolutions.sort(function (a, b) {
    return config.resolutions.indexOf(a) - config.resolutions.indexOf(b);
  });
};

export { config as default, media, mediaQuery, orderResolutions };
